import React, { useState } from 'react';
import { UploadIcon, FileTextIcon, FileIcon, CheckIcon, XIcon } from 'lucide-react';
export const FileUploader = ({
  onUploadComplete
}) => {
  const [isDragging, setIsDragging] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const handleDragOver = e => {
    e.preventDefault();
    setIsDragging(true);
  };
  const handleDragLeave = () => {
    setIsDragging(false);
  };
  const handleDrop = e => {
    e.preventDefault();
    setIsDragging(false);
    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      handleFile(e.dataTransfer.files[0]);
    }
  };
  const handleFileChange = e => {
    if (e.target.files && e.target.files.length > 0) {
      handleFile(e.target.files[0]);
    }
  };
  const handleFile = file => {
    setSelectedFile(file);
  };
  const handleUpload = () => {
    if (!selectedFile) return;
    setIsUploading(true);
    // Simulate file upload
    setTimeout(() => {
      setIsUploading(false);
      // Mock results
      const mockResults = {
        total: 100,
        accepted: 85,
        rejected: 15,
        errors: [{
          line: 5,
          reason: 'Correo inválido',
          data: 'juan@ejemplo'
        }, {
          line: 23,
          reason: 'Falta identificación',
          data: ''
        }, {
          line: 45,
          reason: 'Monto inválido',
          data: 'abc'
        }]
      };
      onUploadComplete(mockResults);
      setSelectedFile(null);
    }, 2000);
  };
  return <div className="space-y-6" data-id="element-596">
      <div className={`border-2 border-dashed rounded-lg p-8 text-center ${isDragging ? 'border-blue-500 bg-blue-50' : 'border-gray-300'}`} onDragOver={handleDragOver} onDragLeave={handleDragLeave} onDrop={handleDrop} data-id="element-597">
        <div className="flex flex-col items-center justify-center" data-id="element-598">
          <UploadIcon className="h-12 w-12 text-gray-400 mb-4" data-id="element-599" />
          <h3 className="text-lg font-medium text-gray-900 mb-1" data-id="element-600">
            Arrastre su archivo aquí
          </h3>
          <p className="text-sm text-gray-500 mb-4" data-id="element-601">
            o haga clic para seleccionar un archivo
          </p>
          <input type="file" className="hidden" accept=".csv,.txt" onChange={handleFileChange} id="file-upload" data-id="element-602" />
          <label htmlFor="file-upload" className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 cursor-pointer" data-id="element-603">
            Seleccionar Archivo
          </label>
        </div>
      </div>
      {selectedFile && <div className="bg-gray-50 p-4 rounded-lg flex items-center justify-between" data-id="element-604">
          <div className="flex items-center" data-id="element-605">
            {selectedFile.name.endsWith('.csv') ? <FileTextIcon className="h-6 w-6 text-blue-500 mr-3" data-id="element-606" /> : <FileIcon className="h-6 w-6 text-blue-500 mr-3" data-id="element-607" />}
            <div data-id="element-608">
              <p className="font-medium" data-id="element-609">{selectedFile.name}</p>
              <p className="text-sm text-gray-500" data-id="element-610">
                {(selectedFile.size / 1024).toFixed(2)} KB
              </p>
            </div>
          </div>
          <div className="flex items-center gap-2" data-id="element-611">
            <button onClick={() => setSelectedFile(null)} className="p-1 text-gray-400 hover:text-gray-600" data-id="element-612">
              <XIcon className="h-5 w-5" data-id="element-613" />
            </button>
            <button onClick={handleUpload} disabled={isUploading} className={`px-4 py-2 rounded-lg ${isUploading ? 'bg-gray-300 text-gray-700' : 'bg-blue-600 text-white hover:bg-blue-700'}`} data-id="element-614">
              {isUploading ? 'Procesando...' : 'Cargar Archivo'}
            </button>
          </div>
        </div>}
    </div>;
};